import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function BedBookingForUsers() {
  const navigate = useNavigate();
  const location = useLocation();

  // ================= GET DATA FROM PREVIOUS PAGE =================
  const bookingData = location.state || {};

  // ================= FETCH VALUES =================
  const userRegisterId = bookingData?.userRegisterId || "";

  const firstName = bookingData?.firstName || "";
  const lastName = bookingData?.lastName || "";

  // FLOOR
  const floorId = bookingData?.floorId || "";
  const floorName = bookingData?.floorName || "";

  // ROOM
  const roomId = bookingData?.roomId || "";
  const roomName = bookingData?.roomName || "";

  // BED
  const bedId = bookingData?.bedId || "";
  const bedName = bookingData?.bedName || "";

  // COST
  const bedCost = bookingData?.bedCost || "";

  // CREATED BY
  const userCreatedBy = JSON.parse(localStorage.getItem("user"))?.emailId || "";

  // ================= STATES =================
  const [loading, setLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false);

  const [form, setForm] = useState({
    bedBookingType: "",
    snoringHabbit: "No",
  });

  // ================= HANDLE CHANGE =================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // ================= BOOK BED =================
  const handleBookBed = async () => {
    if (!form.bedBookingType) {
      alert("Please Select Booking Type");
      return;
    }

    setLoading(true);

    // ================= PAYLOAD =================
    const payload = {
      userRegisterId,

      // FLOOR
      userFloorId: floorId,
      userFloorName: floorName,

      // ROOM
      userRoomId: roomId,
      userRoomName: roomName,

      // BED
      userBedId: bedId,
      userBedName: bedName,

      // COST
      bedCost,

      bedStatus: "BOOKED",

      userCreatedBy,

      bedBookingType: form.bedBookingType,

      snoringHabbit: form.snoringHabbit,
    };

    try {
      const response = await fetch("http://localhost:9777/user/bedBooking", {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        setShowPopup(true);

        setTimeout(() => {
          navigate("/userPaymentForm", {
            state: {
              userBookingId: data?.data?.userBookingId,

              firstName,
              lastName,

              totalBedCost: bedCost,
            },
          });
        }, 1500);
      } else {
        alert(data?.message || "Booking Failed ❌");
      }
    } catch (error) {
      console.error(error);

      alert("Server Error ❌");
    }

    setLoading(false);
  };

  // ================= UI =================
  return (
    <div style={styles.container}>
      {/* SUCCESS POPUP */}
      {showPopup && (
        <div style={styles.popupOverlay}>
          <div style={styles.popupBox}>
            <div style={styles.successIcon}>✅</div>

            <h2 style={styles.popupTitle}>Bed Booked Successfully</h2>

            <p style={styles.popupText}>Redirecting...</p>
          </div>
        </div>
      )}

      <div style={styles.card}>
        <h1 style={styles.title}>🏠 Bed Booking For Users</h1>

        <div style={styles.grid}>
          {/* BOOKING TYPE */}
          <select
            name="bedBookingType"
            value={form.bedBookingType}
            onChange={handleChange}
            style={styles.selectInput}
          >
            <option value="">Select Booking Type</option>

            <option value="AdvanceBooking">Advance Booking</option>

            <option value="BookingNow">Booking Now</option>
          </select>

          {/* SNORING */}
          <div style={styles.radioBox}>
            <label style={styles.label}>Snoring Habit</label>

            <div style={{ marginTop: "10px" }}>
              <input
                type="radio"
                name="snoringHabbit"
                value="Yes"
                checked={form.snoringHabbit === "Yes"}
                onChange={handleChange}
              />{" "}
              Yes
              <input
                type="radio"
                name="snoringHabbit"
                value="No"
                checked={form.snoringHabbit === "No"}
                onChange={handleChange}
                style={{
                  marginLeft: 20,
                }}
              />{" "}
              No
            </div>
          </div>

          {/* FLOOR NAME */}
          <input
            type="text"
            value={floorName}
            readOnly
            placeholder="Floor Name"
            style={styles.floorInput}
          />

          {/* ROOM NAME */}
          <input
            type="text"
            value={roomName}
            readOnly
            placeholder="Room Name"
            style={styles.roomInput}
          />

          {/* BED NAME */}
          <input
            type="text"
            value={bedName}
            readOnly
            placeholder="Bed Name"
            style={styles.bedInput}
          />

          {/* BED COST */}
          <input
            type="text"
            value={bedCost ? `₹ ${bedCost}` : ""}
            readOnly
            placeholder="Bed Cost"
            style={styles.costInput}
          />
        </div>

        {/* SUMMARY SECTION */}
        <div style={styles.summaryContainer}>
          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>🏢 Floor</h3>

            <p style={styles.summaryText}>{floorName || "N/A"}</p>
          </div>

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>🚪 Room</h3>

            <p style={styles.summaryText}>{roomName || "N/A"}</p>
          </div>

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>🛏 Bed</h3>

            <p style={styles.summaryText}>{bedName || "N/A"}</p>
          </div>

          <div style={styles.summaryCard}>
            <h3 style={styles.summaryTitle}>💰 Cost</h3>

            <p style={styles.summaryText}>₹ {bedCost || 0}</p>
          </div>
        </div>

        {/* BUTTON */}
        <button
          style={styles.bookBtn}
          onClick={handleBookBed}
          disabled={loading}
        >
          {loading ? "Booking..." : "🛏 Book Bed"}
        </button>
      </div>
    </div>
  );
}

export default BedBookingForUsers;

// ================= STYLES =================

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg,#dbeafe,#f8fafc,#e0f2fe)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "30px",
    fontFamily: "Segoe UI, sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "1150px",
    background: "#ffffff",
    borderRadius: "24px",
    padding: "40px",
    boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
  },

  title: {
    textAlign: "center",
    fontSize: "38px",
    fontWeight: "bold",
    marginBottom: "35px",
    color: "#0f172a",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(250px,1fr))",
    gap: "20px",
  },

  selectInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #93c5fd",
    background: "#dbeafe",
    fontSize: "15px",
    fontWeight: "600",
    outline: "none",
  },

  radioBox: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #cbd5e1",
    background: "#f8fafc",
  },

  label: {
    fontWeight: "700",
    color: "#1e293b",
  },

  floorInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #93c5fd",
    background: "#dbeafe",
    fontSize: "15px",
    fontWeight: "700",
    color: "#1e3a8a",
    outline: "none",
  },

  roomInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #86efac",
    background: "#dcfce7",
    fontSize: "15px",
    fontWeight: "700",
    color: "#166534",
    outline: "none",
  },

  bedInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #d8b4fe",
    background: "#f3e8ff",
    fontSize: "15px",
    fontWeight: "700",
    color: "#6b21a8",
    outline: "none",
  },

  costInput: {
    padding: "16px",
    borderRadius: "14px",
    border: "2px solid #fdba74",
    background: "#ffedd5",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#ea580c",
    outline: "none",
  },

  summaryContainer: {
    marginTop: "35px",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: "20px",
  },

  summaryCard: {
    background: "linear-gradient(135deg,#2563eb,#06b6d4)",
    color: "#fff",
    borderRadius: "18px",
    padding: "25px",
    textAlign: "center",
    fontWeight: "bold",
  },

  summaryTitle: {
    fontSize: "20px",
    marginBottom: "10px",
  },

  summaryText: {
    fontSize: "16px",
  },

  bookBtn: {
    width: "100%",
    marginTop: "30px",
    padding: "18px",
    border: "none",
    borderRadius: "16px",
    background: "linear-gradient(45deg,#4f46e5,#06b6d4)",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.45)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
  },

  popupBox: {
    width: "380px",
    background: "#fff",
    borderRadius: "24px",
    padding: "40px 30px",
    textAlign: "center",
  },

  successIcon: {
    fontSize: "70px",
    marginBottom: "20px",
  },

  popupTitle: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "bold",
    color: "#16a34a",
  },

  popupText: {
    marginTop: "12px",
    fontSize: "16px",
    color: "#475569",
    fontWeight: "500",
  },
};
